import {useRouteError} from 'react-router-dom'
import {useSetTitleOnResponseError} from './use-set-title-on-response-error'
import {isResponseError} from './response-error'
import {Blankslate} from '@primer/react/experimental'

/**
 * By wrapping an application's custom error boundary with this component,
 * applications will get framework level error boundary support, such as
 * updating the title on a navigation error.
 */
export const RouterErrorBoundary = () => {
  return (
    <Blankslate border={false} spacious={false}>
      <Blankslate.Heading>Unable to load page.</Blankslate.Heading>
      <Blankslate.Description>Please reload page and try again</Blankslate.Description>
    </Blankslate>
  )
}

export const ResponseErrorElement = () => {
  useSetTitleOnResponseError()
  const routeError = useRouteError()

  if (isResponseError(routeError)) {
    return (
      <Blankslate border={false} spacious={false}>
        <Blankslate.Heading>Unable to load page.</Blankslate.Heading>
        <Blankslate.Description>{`Status: ${routeError.response.status} Message: ${routeError.message}`}</Blankslate.Description>
        <Blankslate.Description>Please reload page and try again</Blankslate.Description>
      </Blankslate>
    )
  }

  return null
}

try{ RouterErrorBoundary.displayName ||= 'RouterErrorBoundary' } catch {}
try{ ResponseErrorElement.displayName ||= 'ResponseErrorElement' } catch {}